import { useEffect, useState } from "react";
import API from "../../services/api";

import BusinessLayout from "../layouts/BusinessLayout";

import HomeChefDashboard from "../components/Dashboards/HomeChefDashboard/HomeChefDashboard";
import BakeryDashboard from "../components/Dashboards/BakeryDashboard/BakeryDashboard";
import RestaurantDashboard from "../components/Dashboards/RestaurantDashboard/RestaurantDashboard";
import HotelDashboard from "../components/Dashboards/HotelDashboard/HotelDashboard";
import CateringDashboard from "../components/Dashboards/CateringDashboard/CateringDashboard";
import ProvisionDashboard from "../components/Dashboards/ProvisionDashboard/ProvisionDashboard";
import MenuDrawer from "../components/MenuDrawer/MenuDrawer";
import socket from "../../services/socket";
function BusinessHome() {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    fetchDashboard();
  }, []);
useEffect(() => {

    const user = JSON.parse(

        localStorage.getItem("user")

    );

    if(user){

        socket.emit(

            "register",

            user.id

        );

    }

}, []);
  const fetchDashboard = async () => {
    try {
      setLoading(true);

      const { data } = await API.get("/dashboard");

      setDashboard(data);
    } catch (error) {
      console.error("Dashboard Error:", error.response?.data || error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <BusinessLayout>
        <h2>Loading Dashboard...</h2>
      </BusinessLayout>
    );
  }

  if (!dashboard || !dashboard.provider) {
    return (
      <BusinessLayout>
        <h2>Provider not found.</h2>
      </BusinessLayout>
    );
  }

  const commonProps = {
  provider: dashboard.provider,
  stats: dashboard.stats,
  wallet: dashboard.wallet,
  analytics: dashboard.analytics,
  weeklyRevenue: dashboard.weeklyRevenue,
  recentOrders: dashboard.recentOrders,
  topSellingFoods: dashboard.topSellingFoods,
  recentReviews: dashboard.recentReviews,
  notifications: dashboard.notifications,
  refreshDashboard: fetchDashboard,

  setDrawerOpen,   // <-- ADD THIS
};
 const renderDashboard = (setDrawerOpen) => {
    switch (dashboard.provider.providerType) {
      case "Home Kitchen":
      case "Home Chef":
        return <HomeChefDashboard {...commonProps} />;

      case "Restaurant":
        return <RestaurantDashboard {...commonProps} />;

      case "Hotel":
        return <HotelDashboard {...commonProps} />;

      case "Bakery":
        return <BakeryDashboard {...commonProps} />;

      case "Catering":
        return <CateringDashboard {...commonProps} />;

      case "Provision Store":
        return <ProvisionDashboard {...commonProps} />;

      default:
        return (
          <BusinessLayout>
            <div style={{ padding: "30px" }}>
              <h2>Dashboard not available</h2>

              <p>
                Unknown Provider Type:
                <strong> {dashboard.provider.providerType}</strong>
              </p>
            </div>
          </BusinessLayout>
        );
    }
  };

  return (
    <BusinessLayout
    drawerOpen={drawerOpen}
    setDrawerOpen={setDrawerOpen}
>

    {renderDashboard(setDrawerOpen)}

</BusinessLayout>
  );
}

export default BusinessHome;